/* eslint-disable quotes */
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import Dialog from './Dialog';
// import { SAVE_LOAD_TYPE } from './utils';
// import LoadingButton from './LoadingButton';
// import { cleanBeforeExport } from '../blockly/utils';
import * as style from '../style';
import { translate } from '../../../common/i18n';
// import googleDriveUtil from '../../../common/integrations/GoogleDrive';
// import { observer as globalObserver } from '../../../common/utils/observer';

const Copy = React.memo(({ closeDialog, onSave }) => {
    // const [isLoading, setLoading] = React.useState(false);
    const [tokens, setTokens] = useState(['']); // Initialize with one empty token

    const isLocalhost = window.location.hostname === 'localhost';
    // const [isGdLoggedIn, setGdLoggedIn] = React.useState(false);

    // const isMounted = useIsMounted();

    // React.useEffect(() => {
    //     globalObserver.register('googledrive.authorised', data => setGdLoggedIn(data));
    // }, []);

    // const onChange = e =>
    // e.target.type === 'checkbox' ? setSaveType(e.target.value) : setSaveAsCollection(e.target.checked);


    const addInput = () => {
        setTokens([...tokens, '']); // Add a new empty token
    };

    const handleInputChange = (index, value) => {
        const newTokens = [...tokens];
        newTokens[index] = value;
        setTokens(newTokens);
    };

    const removeInput = (index) => {
        const newTokens = tokens.filter((_, i) => i !== index);
        setTokens(newTokens.length ? newTokens : ['']); // always keep one row to type into
    };

    const onSubmit = (e) => {
        e.preventDefault();
        const tokenObjects = tokens.filter(token => token.trim() !== '').map(token => ({ token }));
        onSave(tokenObjects);
    };

    return (
        <form id="copy-dialog" onSubmit={onSubmit} className="bb3-copy">
            <div className="bb3-dlg-b">
                <h3>{translate('Tokens for copy trading')}</h3>
                <p className="bb3-help">
                    {translate(
                        'Insert the tokens with which you want to copy the trades. To work, all tokens must be valid. They will copy the same stake, trade type, and market.'
                    )}
                </p>
                <ul className="bb3-tokens">
                    {tokens.map((token, index) => (
                        <li key={index}>
                            <label htmlFor={`copy-token-${index + 1}`}>{`${translate('Account token')} ${index + 1}`}</label>
                            <div className="bb3-field">
                                <input
                                    id={`copy-token-${index + 1}`}
                                    className="copy-trading-input"
                                    name={`token${index + 1}`}
                                    title={translate('Account token')}
                                    type="text"
                                    value={token}
                                    onChange={e => handleInputChange(index, e.target.value)}
                                    data-lpignore="true"
                                    autoComplete="off"
                                    spellCheck={false}
                                />
                                <button
                                    type="button"
                                    className="bb3-icon-btn"
                                    aria-label={`${translate('Delete')} ${translate('Account token')} ${index + 1}`}
                                    onClick={() => removeInput(index)}
                                >
                                    <svg viewBox="0 0 24 24" aria-hidden="true">
                                        <path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3" />
                                    </svg>
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
                <button type="button" className="bb3-add" onClick={addInput}>
                    <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M12 5v14M5 12h14" />
                    </svg>
                    {translate('Add token')}
                </button>
            </div>
            <div className="bb3-dlg-f">
                <button type="submit" className="bb3-btn primary">
                    {translate('Save')}
                </button>
            </div>
        </form>
    );
});

Copy.propTypes = {
    closeDialog: PropTypes.func.isRequired,
    onSave     : PropTypes.func.isRequired,
};

export default class CopyDialog extends Dialog {
    constructor() {
        const closeDialog = token => {
            this.close(token);
        };
        const onSave = arg => {
            this.limitsPromise(arg);
            closeDialog();
        };
        super(
            'copy-dialog',
            translate('Copy Trading Tokens'),
            <Copy onSave={onSave} closeDialog={closeDialog} />,
            {
                ...style.dialogLayout,
                width  : 520,
                classes: { 'ui-dialog': 'bb3-dlg bb3-dlg-sm', 'ui-dialog-titlebar-close': 'icon-close' },
            }
        );
        this.registerCloseOnOtherDialog();
    }

    save() {
        this.open();
        return new Promise(resolve => {
            this.limitsPromise = resolve;
        });
    }
}
